import TwentyFourAqua from "../images/customisation-assets/24H_Aqua.png";
import TwentyFourBlue from "../images/customisation-assets/24H_Blue.png";
import TwentyFourBrown from "../images/customisation-assets/24H_Brown.png";
import TwentyFourDarkOrange from "../images/customisation-assets/24H_Dark_Orange.png";
import TwentyFourGrey from "../images/customisation-assets/24H_Grey.png";
import TwentyFourLake from "../images/customisation-assets/24H_Lake.png";
import TwentyFourOrange from "../images/customisation-assets/24H_Orange.png";
import TwentyFourRed from "../images/customisation-assets/24H_Red.png";
import TwentyFourYellow from "../images/customisation-assets/24H_Yellow.png";
import TwentyFourPink from "../images/customisation-assets/24H_Pink.png";
import TwentyFourYellowBlue from "../images/customisation-assets/24H_Yellow_Blue.png";
import TwentyFourAquaLightBlue from "../images/customisation-assets/24H_Aqua_Light_Blue.png";
import TwentyFourRedBlack from "../images/customisation-assets/24H_Red_Black.png";
import TwentyFourGreen from "../images/customisation-assets/24H_Green.png";

// Thumbnails
import TwentyFourBrownThumb from "../images/customisation-asset-thumbnails/24H_Brown_50x50.png";
import TwentyFourGreyThumb from "../images/customisation-asset-thumbnails/24H_Grey_50x50.png";
import TwentyFourLakeThumb from "../images/customisation-asset-thumbnails/24H_Lake_50x50.png";
import TwentyFourOrangeThumb from "../images/customisation-asset-thumbnails/24H_Orange_50x50.png";
import TwentyFourDarkOrangeThumb from "../images/customisation-asset-thumbnails/24H_Dark_Orange_50x50.png";
import TwentyFourYellowThumb from "../images/customisation-asset-thumbnails/24H_Yellow_50x50.png";
import TwentyFourRedThumb from "../images/customisation-asset-thumbnails/24H_Red_50x50.png";
import TwentyFourAquaThumb from "../images/customisation-asset-thumbnails/24H_Aqua_50x50.png";
import TwentyFourBlueThumb from "../images/customisation-asset-thumbnails/24H_Blue_50x50.png";
import TwentyFourPinkThumb from "../images/customisation-asset-thumbnails/24H_Pink_50x50.png";
import TwentyFourYellowBlueThumb from "../images/customisation-asset-thumbnails/24H_Yellow_Blue_50x50.png";
import TwentyFourAquaLightBlueThumb from "../images/customisation-asset-thumbnails/24H_Aqua_Light_Blue_50x50.png";
import TwentyFourRedBlackThumb from "../images/customisation-asset-thumbnails/24H_Red_Black_50x50.png";
import TwentyFourGreenThumb from "../images/customisation-asset-thumbnails/24H_Green_50x50.png";

import { SelectionColours } from "./selection-colors";

export const TWENTY_FOUR_OPTIONS = {
  aqua: {
    title: "Aqua & White",
    watchLayerAsset: TwentyFourAqua,
    watchLayerThumbnail: TwentyFourAquaThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.AQUA, SelectionColours.WHITE],
    },
  },
  blue: {
    title: "Blue & White",
    watchLayerAsset: TwentyFourBlue,
    watchLayerThumbnail: TwentyFourBlueThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BLUE, SelectionColours.WHITE],
    },
  },
  brown: {
    title: "Brown & White",
    watchLayerAsset: TwentyFourBrown,
    watchLayerThumbnail: TwentyFourBrownThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BROWN, SelectionColours.WHITE],
    },
  },
  grey: {
    title: "Grey & White",
    watchLayerAsset: TwentyFourGrey,
    watchLayerThumbnail: TwentyFourGreyThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.GREY, SelectionColours.WHITE],
    },
  },
  lake: {
    title: "Lake Green & White",
    watchLayerAsset: TwentyFourLake,
    watchLayerThumbnail: TwentyFourLakeThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.LAKE, SelectionColours.WHITE],
    },
  },
  darkOrange: {
    title: "Orange & Black",
    watchLayerAsset: TwentyFourDarkOrange,
    watchLayerThumbnail: TwentyFourDarkOrangeThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.DARK_ORANGE, SelectionColours.BLACK],
    },
  },
  orange: {
    title: "Orange & White",
    watchLayerAsset: TwentyFourOrange,
    watchLayerThumbnail: TwentyFourOrangeThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.ORANGE, SelectionColours.WHITE],
    },
  },
  red: {
    title: "Red & White",
    watchLayerAsset: TwentyFourRed,
    watchLayerThumbnail: TwentyFourRedThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.RED, SelectionColours.WHITE],
    },
  },
  yellow: {
    title: "Yellow & White",
    watchLayerAsset: TwentyFourYellow,
    watchLayerThumbnail: TwentyFourYellowThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.YELLOW, SelectionColours.WHITE],
    },
  },
  pink: {
    title: "Pink & Black",
    watchLayerAsset: TwentyFourPink,
    watchLayerThumbnail: TwentyFourPinkThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.PINK, SelectionColours.BLACK],
    },
  },
  yellowBlue: {
    title: "Yellow & Blue",
    watchLayerAsset: TwentyFourYellowBlue,
    watchLayerThumbnail: TwentyFourYellowBlueThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.SUNSHINE_YELLOW, SelectionColours.CYAN],
    },
  },
  aquaLightBlue: {
    title: "Aqua & Light Blue",
    watchLayerAsset: TwentyFourAquaLightBlue,
    watchLayerThumbnail: TwentyFourAquaLightBlueThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.AQUA, SelectionColours.LIGHT_BLUE],
    },
  },
  redBlack: {
    title: "Red & Black",
    watchLayerAsset: TwentyFourRedBlack,
    watchLayerThumbnail: TwentyFourRedBlackThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.RED, SelectionColours.BLACK],
    },
  },
  green: {
    title: "Green & Black",
    watchLayerAsset: TwentyFourGreen,
    watchLayerThumbnail: TwentyFourGreenThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.FOREST_GREEN, SelectionColours.BLACK],
    },
  },
};
